<template>
  <footer class="revenues-footer" :class="className">
    <div>
      <span>{{ $t('finances.revenues.appointments') }}</span>
      {{ total.appointments }}
    </div>
    <div>
      <span>{{ $t('finances.revenues.total') }}</span>
      {{ formatPrice(total.value) }}
    </div>
  </footer>
</template>

<script>
import helper from '@/mixins/helper';

export default {
  mixins: [helper],

  props: {
    total: Object,
    className: String,
  },
};
</script>

<style lang="scss">
@import '@/styles/custom.scss';

.revenues-footer {
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  padding: 5px 15px;
  font-size: 13px;

  span:after {
    content: ':';
  }

  &.print {
    display: none;
  }
}
</style>
